import {
  INITIATIVE_PAGE_CONTENT,
  LEADERSHIP_PAGE_CONTENT,
  WELCOME_PAGE_CONTENT,
} from "./siteVerbiage";

export const APPLICATION_ROUTES = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "Behind The Initiative",
    path: "/behind-the-initiative",
  },
  {
    name: "Leadership",
    path: "/leadership",
  },
  {
    name: "Contact the Team",
    path: `/leadership/#${LEADERSHIP_PAGE_CONTENT.CONTACT.ID}`,
  },
];

export const FOOTER_LINKS = [
  {
    name: "Home",
    path: "/",
    subLinks: [
      {
        name: "What Is EMPD?",
        path: `/#${WELCOME_PAGE_CONTENT.WHAT_IS_EMPD.ID}`,
      },
      {
        name: "EMPD Challenges",
        path: `/#${WELCOME_PAGE_CONTENT.CHALLENGES.ID}`,
      },
      {
        name: "Our Vision",
        path: `/#${WELCOME_PAGE_CONTENT.OUR_VISION.ID}`,
      },
    ],
  },
  {
    name: "Behind The Initiative",
    path: "/behind-the-initiative",
    subLinks: [
      {
        name: "Transformative",
        path: `/behind-the-initiative/#${INITIATIVE_PAGE_CONTENT.TRANSFORMATIVE.ID}`,
      },
      {
        name: "Global Mission",
        path: `/behind-the-initiative/#${INITIATIVE_PAGE_CONTENT.GLOBAL.ID}`,
      },
      {
        name: "Generously Supported",
        path: `/behind-the-initiative/#${INITIATIVE_PAGE_CONTENT.SUPPORT.ID}`,
      },
    ],
  },
  {
    name: "Who We Are",
    path: "/leadership",
    subLinks: [
      {
        name: "About Our Leadership",
        path: `/leadership/#${LEADERSHIP_PAGE_CONTENT.WHO_WE_ARE.ID}`,
      },
      {
        name: "Contact the Team",
        path: `/leadership/#${LEADERSHIP_PAGE_CONTENT.CONTACT.ID}`,
      },
    ],
  },
];

export const PRIMARY_LINK = {
  name: "Sign In or Sign Up",
  path: "/patient-registration",
};
